const DemoMenu = {
    pages: [
        {
            title: 'keywords',
            name: 'KEYWORDS'
        },
        {
            title: 'topic-comparison',
            name: 'TOPIC_COMPARISON'
        },
        {
            title: 'sample',
            name: 'SAMPLE'
        },
        {
            title: 'extended_analytic',
            name: 'EXTENDED_ANALYTIC'
        },
        {
            title: 'reports',
            name: 'REPORTS'
        },
        {
            title: 'dashboards',
            name: 'DASHBOARDS'
        },
        {
            title: 'notifications',
            name: 'NOTIFICATIONS'
        }
    ]
}

export default DemoMenu;